import React from 'react';

import {
  useRestrictedActionShowState,
  useRestrictedActionShowActions,
} from './RestrictedActionShowContext';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import DeleteRestrictedActionForm from './DeleteRestrictedActionForm';

const DeleteRestrictedActionModal = () => {
  const state = useRestrictedActionShowState();
  const { closeDeleteRestrictedActionModal } = useRestrictedActionShowActions();

  return (
    <StandardModal
      isOpen={state?.deleteRestrictedActionModalIsOpen}
      contentLabel="Delete Restricted Action"
      onRequestClose={() => {
        closeDeleteRestrictedActionModal();
      }}
    >
      <DeleteRestrictedActionForm />
    </StandardModal>
  );
};

export default DeleteRestrictedActionModal;
